import { render, staticRenderFns } from "./ResidentRegister.vue?vue&type=template&id=2efa8bae&scoped=true&lang=pug"
import script from "./ResidentRegister.vue?vue&type=script&lang=ts"
export * from "./ResidentRegister.vue?vue&type=script&lang=ts"
import style0 from "./ResidentRegister.vue?vue&type=style&index=0&id=2efa8bae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efa8bae",
  null
  
)

export default component.exports